//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const WriteDatasourceUsage: FeatureFlag = {"Id":"WriteDatasourceUsage","Label":"Write usage of datasource","Impact":"Legacy. To be removed. Don't change","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
